import { useAsync } from 'core/ui/hooks/useAsync'

import { uploadDocument } from '../../use-cases/uploadDocument'

export function useUploadDocument() {
  const { call, reset, status, isInitial, isPending, isDone, hasError } = useAsync(uploadDocument)
  return { uploadDocuments: call, reset, status, isInitial, isPending, isDone, hasError }
}
